import { create } from 'zustand';
import { api } from '../api.js';

export const useAuthStore = create((set) => ({
  isAuthenticated: false,
  user: null,
  loading: true,

  checkAuth: async () => {
    try {
      const data = await api.checkAuth();
      if (data?.authenticated) {
        set({ isAuthenticated: true, user: data.user || 'admin', loading: false });
        return true;
      }
    } catch {
      // not authenticated
    }
    set({ isAuthenticated: false, user: null, loading: false });
    return false;
  },

  login: async (login, password) => {
    const res = await api.login(login, password);
    if (res?.token) {
      localStorage.setItem('scb_auth_token', res.token);
    }
    set({ isAuthenticated: true, user: res?.user || login, loading: false });
    return res;
  },

  logout: async () => {
    try {
      await api.logout();
    } catch {
      // ignore
    }
    localStorage.removeItem('scb_auth_token');
    set({ isAuthenticated: false, user: null, loading: false });
  },
}));
